export const COMPONENT_CONFIG_FETCH_REQUEST = 'COMPONENT_CONFIG:FETCH_REQUEST';
export const COMPONENT_CONFIG_FETCH_SUCCESS = 'COMPONENT_CONFIG:FETCH_SUCCESS';
export const COMPONENT_CONFIG_FETCH_FAILURE = 'COMPONENT_CONFIG:FETCH_FAILURE';
export const COMPONENT_CONFIG_RESET = 'COMPONENT_CONFIG:RESET';
export const COMPONENT_CONFIG_ACTION_PERFORMED = 'COMPONENT_CONFIG:ACTION_PERFORMED';
export const COMPONENT_CONFIG_ACTION_PERFORMED_SUCCESS = 'COMPONENT_CONFIG:ACTION_PERFORMED_SUCCESS';
export const COMPONENT_CONFIG_ACTION_PERFORMED_FAILURE = 'COMPONENT_CONFIG:ACTION_PERFORMED_FAILURE';
